import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class MonthlyGoalService {

    private goalSubject = new BehaviorSubject<number | null>(null);
    private dailyGoalSubject = new BehaviorSubject<number | null>(null);
    goal$ = this.goalSubject.asObservable();
    dailyGoal$ = this.dailyGoalSubject.asObservable();

    setGoal(value: number) {
        console.log("📢 Service monthly updated with: ", value);
        this.goalSubject.next(value);
    }

    setDailyGoal(dailyGoal: number): void {
        console.log("📢 Service daily updated with: ", dailyGoal);
        this.dailyGoalSubject.next(dailyGoal);
    }

    getGoal(): number {
        return this.goalSubject.getValue() ?? 0;
    }

    getDailyGoal(): number {
        return this.dailyGoalSubject.getValue() ?? 0;
    }

}
